module.exports = __webpack_public_path__ + "img/Outubro_Rosa.d054721d.jpg";